import * as types from '../constants/ActionTypes'

import 'whatwg-fetch';

const server = window.server || "";

export const getApp = (id) => {
	return (dispatch,getState) => {
        var data = new FormData();
		data.append("type","get");
        fetch(server + "/v1/app/"+id,{
			method: 'post',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(data){
			dispatch({type:types.GET_APP,data});
        }).catch(function(ex) {
			console.log('parsing failed', ex)
		});
    }
}

export const getDeb = (id) => {
	return (dispatch,getState) => {
        var data = new FormData();
		data.append("type","get");
        fetch(server + "/v1/deb/"+id,{
			method: 'post',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(data){
            //console.log("data:",data);
			//dispatch({type:types.GET_APP,data});
        }).catch(function(ex) {
			console.log('parsing failed', ex)
		});
    }
}

const getParams = data => {
	let result = [];
	for (let key in data) {
		if (data.hasOwnProperty(key)) {
			result.push(encodeURIComponent(key) + "=" + encodeURIComponent(data[key]));
		}
	}
	return result.join("&");
}

//提交表单保存
export const saveOrderFields = data => {
	return {type:types.SAVE_ORDER_FIELDS,data:data}
}

//重置客户列表参数
export const resetCustomerParams = () => {
	return {type:types.RESET_CUSTOMER_PARAMS}
}

//客户列表下一页
export const goNextPage = data => {
	return dispatch => {
		dispatch({type:types.GO_NEXT_PAGE,data:data});
		dispatch(getCustomerlist());
	}
}

//获取客户列表
export const getCustomerlist = () =>{
	return (dispatch,getState) => {
		dispatch({type:types.SET_LOADING,data:true});
		const {app} = getState();
		fetch(server + "/v1/getDeV2?" + getParams(app.customerParams),{
			method: 'GET'
		}).then(res => {
			return res.json();
		}).then(data => {
			dispatch({type:types.SET_LOADING,data:false});
			data.status == 'true' ? dispatch({type:types.GET_CUSTOMER_LIST,data:data}) : console.log('获取数据失败');
		}).catch(ex=> {
			console.log('parsing failed', ex)
		});
	}
}

//获取订单用户license
export const getLicense = params =>{
	return dispatch => {
		fetch(server + "/v2/license",{
			method: 'POST',
			body: getPostParams(params)
		}).then(res => {
			return res.json();
		}).then(data => {
			dispatch(setLicense(data.datas));
		}).catch(ex=> {
			console.log('parsing failed', ex)
		});
	}
}

export const setLicense = params =>{
	return {type:types.GET_LICENSE,data:params}
}

//提交订单
export const doOrderSubmit = params =>{
	return dispatch => {
		dispatch({type:types.SET_LOADING,data:true});
		fetch(server + "/v2/order/add",{
			method: 'POST',
			body: getPostParams(params)
		}).then(res => {
			return res.json();
		}).then(data => {
			dispatch({type:types.SET_LOADING,data:false});
			if(data.status == "true"){
				dispatch({type:types.SET_SUCCESS,data:true});
			}else{
				alert('提交失败，请重新提交！');
			}
		}).catch(ex=> {
			console.log('parsing failed', ex)
		});
	}
}
export const chooseCustomer = value =>{
	console.log(value);
	return {type:types.CHOOSE_CUSTOMER,data:value}
}

const getPostParams = data => {
	let result = new FormData();
	for (let key in data) {
		if (data.hasOwnProperty(key)) {
			result.append(key, data[key]);
		}
	}
	return result
}


// WEBPACK FOOTER //
// ./project/actions/app.js